import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const defaultPageSections = [
  {
    id: "current",
    label: "Current",
  },
  {
    id: "upcoming",
    label: "Upcoming",
  },
  {
    id: "past",
    label: "Past",
  },
];

function PageSectionNav({ visibleSections }) {
  const [active, setActiveSection] = useState("current");
  const availableSections = defaultPageSections.filter((section) => {
    if (!visibleSections) return true;
    return visibleSections[section.id];
  });

  return (
    <nav className="m-sibling-nav__nav" aria-label="Page sections">
      <ul className="m-sibling-nav__list">
        {availableSections.map((section) => (
          <li key={section.id} className="m-sibling-nav__item">
            <a
              href={`#${section.id}`}
              className={classNames({
                "m-sibling-nav__link": true,
                "m-sibling-nav__link--is-active": section.id === active,
              })}
              onClick={(event) => setActiveSection(section.id)}
            >
              {section.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

PageSectionNav.displayName = "ExhibitionsLanding.NavBar.PageSectionNav";

PageSectionNav.propTypes = {
  visibleSections: PropTypes.object,
};

export default PageSectionNav;
